import script from "./tipsComponets.vue?vue&type=script&setup=true&lang=js"
export * from "./tipsComponets.vue?vue&type=script&setup=true&lang=js"

import "./tipsComponets.vue?vue&type=style&index=0&id=32896b8f&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32896b8f"]])

export default __exports__